import {
    FaCalendarAlt,
    FaCar,
    FaCheckCircle,
    FaCog,
    FaCreditCard,
    FaBuilding,
    FaGlobe,
    FaMapSigns,
    FaPlug,
    FaPlusCircle,
    FaShieldAlt,
    FaUsers,
} from "react-icons/fa";
import { HiSparkles } from "react-icons/hi";
import { MdDashboard, MdOutlinePolicy } from "react-icons/md";

export const TOUR_ICON_MAP = {
    welcome: HiSparkles,
    dashboard: MdDashboard,
    sidebarNav: FaMapSigns,
    sidebarDashboard: MdDashboard,
    sidebarCars: FaCar,
    sidebarReservations: FaCalendarAlt,
    sidebarCustomers: FaUsers,
    sidebarInsurance: FaShieldAlt,
    carsTabs: FaCar,
    carsAdd: FaPlusCircle,
    payments: FaCreditCard,
    insuranceSettings: FaShieldAlt,
    insuranceHub: MdOutlinePolicy,
    insuranceSales: MdOutlinePolicy,
    insuranceSellButton: FaPlusCircle,
    reservations: FaCalendarAlt,
    customers: FaUsers,
    sidebarSettings: FaCog,
    settingsCompanyInfo: FaBuilding,
    settingsIntegration: FaPlug,
    integrationTabs: FaPlug,
    settingsBookingSite: FaGlobe,
    bookingSite: FaGlobe,
    settingsMenu: FaCog,
    finish: FaCheckCircle,
    replay: FaMapSigns,
};

export const getTourIcon = (id) => TOUR_ICON_MAP[id] || HiSparkles;
